// extracted by mini-css-extract-plugin
export default {"tasks":"zO-z","task":"AO-z","svg":"BO-z","text":"CO-z"};